import './Footer.css'

const Footer: React.FC = () => {
    return (
        <>
            <footer id="footer">
                <div id="footer-info">
                    <a target='_blank' href="https://github.com/The-taylord">© 2022 Waynon Taylor</a>
                </div>
            </footer>
        </>
    )
}

export default Footer
